import { createRoot } from "react-dom/client";
import VerzuimCalculator from "./calculator.jsx";
import "./style.scss";

/**
 * Frontend mount. render.php levert een <div class="alpina-vc"> met de
 * REST-URL, nonce, Gutenberg-copy en cijfers in data-attributen.
 */
function parseJsonAttr(value) {
	if (!value) return null;
	try {
		return JSON.parse(value);
	} catch (err) {
		return null;
	}
}

function boot() {
	document.querySelectorAll(".alpina-vc").forEach((el) => {
		if (el.dataset.mounted) return;
		el.dataset.mounted = "1";
		const copy = parseJsonAttr(el.dataset.copy) || {};
		const presets = parseJsonAttr(el.dataset.presets);
		createRoot(el).render(
			<VerzuimCalculator
				restUrl={el.dataset.rest || ""}
				nonce={el.dataset.nonce || ""}
				copy={copy}
				presets={Array.isArray(presets) ? presets : undefined}
				showYearlyRisk={el.dataset.showYearly === "1"}
				showContextNote={el.dataset.showContext === "1"}
				fietsPrijs={el.dataset.fietsPrijs ? Number(el.dataset.fietsPrijs) : undefined}
				fietsMargePercent={el.dataset.fietsMarge ? Number(el.dataset.fietsMarge) : undefined}
			/>
		);
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
